import { Directive, ElementRef, AfterViewInit, Input } from '@angular/core';

@Directive({
  selector: '[ariaLabelTarget]'
})
export class AriaLabelTargetDirective implements AfterViewInit {
  @Input() targetSelector: string = '';
  @Input() ariaLabelText: string = '';

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    setTimeout(() => {
      const target = this.el.nativeElement.querySelector(this.targetSelector);
      if (target) {
        target.setAttribute('aria-label', this.ariaLabelText);
      }
    });
  }
}